<div class="info-popup info-popup--error" [attr.role]="notification.role" [attr.aria-live]="notification.ariaLive">
    <!-- <div class="info-popup__close">
        <span class="icon icon-mobile-delete"></span>
    </div> -->
    <div class="info-popup__type">
        <img class="info-popup__icon icon icon-error hide-for-wcag" src="assets/icon_notification_error.png" alt="" />
        <img class="info-popup__icon icon icon-error show-high-contrast-view" src="assets/icon_notification_error-wcag.png" alt="" />
    </div>
    <div class="info-popup__title">
        {{ title | translate }}
    </div>

    <div class="info-popup__text">
        <ng-container *ngIf="notification.translate">
            {{ message | translate }}
        </ng-container>
        <ng-container *ngIf="!notification.translate">
            <ng-container
                *ngIf="notification.translations.length > 0 && (notification | translateObjectField: 'message':locale)"
            >
                {{ notification | translateObjectField: 'message':locale }}
            </ng-container>
            <ng-container
                *ngIf="notification.translations.length > 0 && !(notification | translateObjectField: 'message':locale)"
            >
                {{ notification.message ? notification.message : '' }}
            </ng-container>
            <ng-container *ngIf="notification.translations.length === 0">
                {{ notification.message }}
            </ng-container>
        </ng-container>
    </div>
</div>
